import { render, staticRenderFns } from "./ColissimoModal.html?vue&type=template&id=636607ac&scoped=true&"
import script from "./ColissimoModal.vue?vue&type=script&lang=js&"
export * from "./ColissimoModal.vue?vue&type=script&lang=js&"
import style0 from "./ColissimoModal.scss?vue&type=style&index=0&id=636607ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636607ac",
  null
  
)

export default component.exports